import OWContainer from 'styles/styled-components/ow-container';
import { TerminalForm } from '../components/terminal-form';
import useController from '../controllers/add-terminal-controller';

export const AddTerminalRoute = () => {
    const { errors, onCancel, onChange, onSubmit, formData, isAddTerminalLoading } = useController();

    return (
        <OWContainer>
            <TerminalForm
                formData={formData}
                errors={errors}
                onCancel={onCancel}
                onChange={onChange}
                onSubmit={onSubmit}
                isSaveLoading={isAddTerminalLoading}
            />
        </OWContainer>
    );
};
